import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { ColorPicker } from '@syncfusion/ej2-inputs';
export class ColorPickerRenderer {
    constructor(editor) {
        this.editor = editor;
    }
    /**
     * Renders the colorpicker with the specified options.
     *
     * @param {IColorPickerRenderOptions} args - The options for rendering the colorpicker.
     * @returns {ColorPicker} - The rendered colorpicker instance.
     * @hidden
     */
    renderColorPicker(args) {
        const isBackground = args.type === 'bgColor';
        const fontColor = this.editor.fontColorSettings;
        const bgColor = this.editor.backgroundColorSettings;
        const mode = isBackground ? (bgColor.mode) : (fontColor.mode);
        const colorCode = isBackground ? (bgColor.colorCode) : (fontColor.colorCode);
        const modeSwitcher = isBackground ? !!bgColor.modeSwitcher : !!fontColor.modeSwitcher;
        const columns = isBackground ? (bgColor.columns) : (fontColor.columns);
        const value = isBackground ? (bgColor.default) : (fontColor.default);
        const colorPicker = new ColorPicker({
            enableRtl: this.editor.enableRtl,
            inline: false,
            mode: mode,
            modeSwitcher: modeSwitcher,
            noColor: true,
            showButtons: false,
            cssClass: this.editor.cssClass + 'e-be-color-picker',
            columns: columns,
            presetColors: colorCode,
            created: () => {
                const host = args.element.parentElement;
                host.tabIndex = -1;
                const cssClasses = colorPicker.cssClass.split(' ').filter(Boolean);
                const splitDiv = host.childNodes[1];
                splitDiv.classList.add(...cssClasses);
                const dropdownCls = args.type === 'bgColor' ? 'e-be-bgcolor-dropdown' : 'e-be-fontcolor-dropdown';
                const splitPickerElem = host.querySelector('.e-split-colorpicker');
                splitPickerElem.classList.add(...cssClasses);
                splitPickerElem.classList.add('e-dropdown', dropdownCls, 'e-icons');
                const dropdownBtn = host.querySelector('.e-dropdown-btn');
                dropdownBtn.classList.add(...cssClasses);
                dropdownBtn.classList.add('e-dropdown', dropdownCls);
                colorPicker.setProperties({ value: value });
            },
            beforeTileRender: (args) => {
                args.element.classList.add('e-color-palette');
                args.element.classList.add('e-custom-tile');
                if (args.value === '') {
                    args.element.classList.add('e-no-color');
                }
            },
            change: (pickerArgs) => {
                const colorpickerValue = pickerArgs.currentValue.rgba;
                args.onChange(colorpickerValue);
            },
            beforeModeSwitch: (args) => {
                const currentValue = colorPicker.value;
                if (currentValue === '') {
                    colorPicker.setProperties({ value: (args.mode === 'Picker') ? '#008000ff' : '' }, true);
                }
            }
        });
        colorPicker.appendTo(args.element);
        return colorPicker;
    }
    updatePickerProperties(picker, model) {
        const props = {};
        if (!isNullOrUndefined(model.default)) {
            props.value = model.default;
        }
        if (!isNullOrUndefined(model.columns)) {
            props.columns = model.columns;
        }
        if (!isNullOrUndefined(model.modeSwitcher)) {
            props.modeSwitcher = model.modeSwitcher;
        }
        if (!isNullOrUndefined(model.colorCode)) {
            props.presetColors = model.colorCode;
        }
        if (!isNullOrUndefined(model.mode)) {
            props.mode = model.mode;
        }
        if (Object.keys(props).length) {
            picker.setProperties(props);
        }
    }
}
